module.exports = __webpack_public_path__ + "media/images/vp/icon.edit.outline.black-f28e0aa4d65a869b8224ef4603a4fc4e.svg";